import { SERVICES_URL, handleError } from "api/helper";

import { post } from "api/http";

const baseUrl = "seller/auth/v1";

export interface InviteSellersRequest {
  propertyId: string;
  invitedSellerEmails: string[];
  personalizedMessage: string;
}

export const inviteSellers = (model: InviteSellersRequest) =>
  post(`${SERVICES_URL}/${baseUrl}/invite-seller`, model).catch(handleError);
